import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link } from "react-router-dom";

const AdminBackButton = () => {
  return (
    <div style={{ textAlign: "right", paddingRight: "10px" }}>
      <Link to="/certificates">
        <div>
          <ArrowBackIcon color={"info"} />
        </div>
      </Link>
    </div>
  );
};
export default AdminBackButton;
